export const VENDOR_ENDPOINTS = {
  suggestions: 'https://autocomplete.diginetica.net/autocomplete',
};
